import React, { memo, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { VERTICAL_URL } from 'settings';
import Modal from 'v2/components/Shared/Modal';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const ModalOwnership = memo(() => {
  const history = useHistory();

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(prev => !prev), []);

  function onClose() {
    toggle();
  }

  function onProceed() {
    const userHasRemoveNewBankAccountsBeta = eduzzAccountsService.verifyUserHasBetaModule('remove_new_bank_accounts');

    if (userHasRemoveNewBankAccountsBeta) {
      history.push('/producer/profile/bankdata');
      return;
    }

    window.location.href = `${VERTICAL_URL}/bank-accounts/`;
  }

  React.useEffect(() => {
    if (user?.show_account_owner_change_modal) {
      toggle();
    }
  }, [toggle, user]);

  return (
    <Modal
      size='xs'
      open={open}
      setClose={onClose}
      textTitle='Atenção'
      textReturnButton=''
      textProceedButton='Ir para Dados Bancários'
      handleProceedClick={onProceed}
    >
      <p className='[&:not(:last-of-type)]:mb-2'>
        Após a troca de titularidade, as contas bancárias serão <strong>canceladas</strong> para a sua segurança.
      </p>
      <p className='[&:not(:last-of-type)]:mb-2'>
        Você pode cadastrar sua nova conta bancária de forma <strong>simples e rápida</strong>, basta clicar em{' '}
        <strong>Ir para Dados bancários</strong> e depois em <strong>Cadastrar nova conta</strong>.
      </p>
      <p className='[&:not(:last-of-type)]:mb-2'>
        Qualquer dúvida, entre em contato com o nosso suporte. Estamos à disposição!
      </p>
    </Modal>
  );
});

export default ModalOwnership;
